import { SetRoutes } from 'components';
import routes from './routes';
const CompanyCategoriesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default CompanyCategoriesPages;
